// 固定资产处置流程 | vuex store
// Author Liang Gangqiang
// Date 2026-09-07

import * as model from "@/model/em/asset/EmArchFixedAssetDisposalModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    return Object.assign({}, paginationFilter, model.filter);
}

export default newEntityStoreHelper(() => new model.EmArchFixedAssetDisposal(), newFilter)
    .withStates({
        // spec D13：复用 em-archive 的 env 变量，不新增 VUE_APP_*（否则要改 16 份 .env*）
        baseModuleUrl: process.env.VUE_APP_EM_ARCHIVE_URL,
        // ⚠ 必须指向业务侧的 /emArchFixedAssetDisposal/complete-feedback，
        //   而不是基类 EmBaseWorkflowCommonResource 的
        //   /emArchFixedAssetDisposal/workflow/complete-feedback：
        //   基类那条映射挂在包级可见方法上，跨包子类的同名方法不构成 override，两条路径都会注册，
        //   但基类那条只做 updateStatusDirect —— 指错了「当前处理人维护 / 三个 EndEvent 的资产状态
        //   回写 / 销账时间 / 通知」整段业务逻辑都不会执行，而且不报错（S5 已知约束）。
        //   正确先例：EmMaMaintenanceWoStore / SithMesPrdZpp1Store / EmArchFixedAssetChangeStore。
        callbackApi: process.env.VUE_APP_EM_ARCHIVE_URL + '/emArchFixedAssetDisposal/complete-feedback',
        processDefinitionKey: "em_arch_fixed_asset_disposal",
        processBusinessData: Object
    })
    .withMutations({
        setProcessBusinessData(state, data) {
            state.processBusinessData = data
        }
    })
    .buildStore()
